import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
/* global define */
(function () {

  var hasOwn = {}.hasOwnProperty;

  function classNames() {
    var classes = [];

    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (!arg) continue;
      var argType = typeof arg;

      if (argType === 'string' || argType === 'number') {
        classes.push(arg);
      } else if (Array.isArray(arg) && arg.length) {
        var inner = classNames.apply(null, arg);

        if (inner) {
          classes.push(inner);
        }
      } else if (argType === 'object') {
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        }
      }
    }

    return classes.join(' ');
  }

  if ( module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else {
    window.classNames = classNames;
  }
})();
});

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */
function throttle(delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

var isChildType = function isChildType(child, component) {
  try {
    var _child$type;

    if (component != null && component.displayName && child != null && (_child$type = child.type) != null && _child$type.displayName) {
      return component.displayName === child.type.displayName;
    }
  } catch (_unused) {
    console.error("Unable to match React children type");
  }

  return false;
};

var findByType = function findByType(children, component) {
  /* This is the array of result since Article can have multiple times the same sub-component */
  var result = [];
  /* Then we go through each React children, if one of matches the name of the sub-component we’re looking for we put it in the result array */

  React.Children.forEach(children, function (child) {
    if (isChildType(child, component)) {
      result.push(child);
    }
  }); // Return first result;

  return result[0];
};

var modules_7fb06468 = {"info":"InfoPanel_module_info__3289a742"};

var View = function View() {
  return null;
};

View.displayName = "InfoPanelView";

var Info = function Info() {
  return null;
};

Info.displayName = "InfoPaneInfo";

var InfoPanel = function InfoPanel(_ref) {
  var children = _ref.children,
      isActive = _ref.isActive,
      className = _ref.className;
  var infoEl = useRef(null);

  var _useState = useState(0),
      height = _useState[0],
      setHeight = _useState[1];

  useEffect(function () {
    var _infoEl$current;

    setHeight(infoEl == null ? void 0 : (_infoEl$current = infoEl.current) == null ? void 0 : _infoEl$current.clientHeight);
  }, [infoEl, isActive]);
  useEffect(function () {
    var handleResize = throttle(200, function () {
      var _infoEl$current2;

      setHeight(infoEl == null ? void 0 : (_infoEl$current2 = infoEl.current) == null ? void 0 : _infoEl$current2.clientHeight);
    });
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  });

  var renderView = function renderView() {
    var view = findByType(children, View);

    if (!view) {
      return null;
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, view.props.children);
  };

  var renderInfo = function renderInfo() {
    var info = findByType(children, Info);

    if (!info) {
      return null;
    }

    return isActive && /*#__PURE__*/React.createElement("div", {
      className: classnames(modules_7fb06468.info, info.props.className, className),
      ref: infoEl
    }, info.props.children);
  };

  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: (height || 0) + "px"
    }
  }, renderView(), renderInfo());
};

InfoPanel.View = View;
InfoPanel.Info = Info;
InfoPanel.propTypes = {
  children: PropTypes.oneOfType([View, Info]).isRequired,
  isActive: PropTypes.bool,
  className: PropTypes.string
};
InfoPanel.defaultProps = {
  isActive: false,
  className: undefined
};

export default InfoPanel;
export { InfoPanel };
//# sourceMappingURL=index.js.map
